// kware start edit - Backdated checkout: date/time picker component
// Allows staff with permission to set a past loan date for retroactive checkouts
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import {
  Col,
  Datepicker,
  Icon,
  Label,
  Timepicker,
} from '@folio/stripes/components';
import { IfPermission } from '@folio/stripes/core';

import css from './CheckoutDateTime.css';

export const parser = (value) => (value);

class CheckoutDateTime extends React.Component {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    showPickers: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
  };

  render() {
    const {
      intl: { formatMessage },
      showPickers,
      onClick,
      onReset,
    } = this.props;

    const dateLoanedLabel = formatMessage({ id: 'ui-checkout.checkoutDate' });
    const timeLoanedLabel = formatMessage({ id: 'ui-checkout.checkoutTime' });

    return (
      // kware: using ui-checkout.backdateCheckout permission for backdated checkout
      <IfPermission perm="ui-checkout.backdateCheckout">
        <>
          <Col xs={12} sm={2}>
            {showPickers ? (
              <div data-test-checkout-process-date>
                <Field
                  name="item.checkoutDate"
                  aria-label={dateLoanedLabel}
                  label={dateLoanedLabel}
                  component={Datepicker}
                  autoComplete="off"
                  timeZone="UTC"
                  backendDateStandard="YYYY-MM-DD"
                />
              </div>
            ) : (
              <>
                <Label>{dateLoanedLabel}</Label>
                <button
                  data-test-checkout-modify-date
                  onClick={onClick}
                  className={css['modify-datetime-button']}
                  type="button"
                >
                  <Icon icon="edit" iconPosition="end">
                    <FormattedMessage id="ui-checkout.today" />
                  </Icon>
                </button>
              </>
            )}
          </Col>
          <Col xs={12} sm={2}>
            {showPickers ? (
              <div data-test-checkout-process-time>
                <Field
                  name="item.checkoutTime"
                  aria-label={timeLoanedLabel}
                  label={timeLoanedLabel}
                  component={Timepicker}
                  autoComplete="off"
                  timeZone="UTC"
                  parser={parser}
                />
              </div>
            ) : (
              <>
                <Label>{timeLoanedLabel}</Label>
                <button
                  data-test-checkout-modify-time
                  onClick={onClick}
                  className={css['modify-datetime-button']}
                  type="button"
                >
                  <Icon icon="edit" iconPosition="end">
                    <FormattedMessage id="ui-checkout.now" />
                  </Icon>
                </button>
              </>
            )}
          </Col>
          {showPickers && (
            <Col xs={12} sm={1}>
              <Label>&nbsp;</Label>
              <button
                data-test-checkout-reset-date
                onClick={onReset}
                className={css['modify-datetime-button']}
                type="button"
              >
                <Icon icon="times-circle">
                  <FormattedMessage id="ui-checkout.resetToNow" />
                </Icon>
              </button>
            </Col>
          )}
        </>
      </IfPermission>
    );
  }
}

export default injectIntl(CheckoutDateTime);
// kware end edit
